import React, { useEffect } from "react";
import Header from "../components/Header";
import { Box, Typography, Button, useMediaQuery, useTheme } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from "react-router-dom";

export default function PedidoEfetuado() {
		// Remove scroll do body/html enquanto esta página estiver montada
		useEffect(() => {
			document.body.style.overflow = 'hidden';
			document.documentElement.style.overflow = 'hidden';
			return () => {
				document.body.style.overflow = '';
				document.documentElement.style.overflow = '';
			};
		}, []);
		// Nenhuma lógica de autenticação nesta página. Pode ser acessada sem login, igual ao selfcheckout.
	const history = useHistory();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const headerHeight = isMobile ? 56 : 64;
	return (
		<React.Fragment>
			{/* Header com logo, sem botões */}
			<Header showButtons={false} />
			<Box
				bgcolor="#f3f6fa"
				display="flex"
				justifyContent="center"
				alignItems="center"
				p={isMobile ? 1 : 4}
				style={{
				position: 'absolute',
				top: headerHeight,
				left: 0,
				right: 0,
				bottom: 0,
				height: `calc(${window.CSS && CSS.supports('height: 100dvh') ? '100dvh' : '100vh'} - ${headerHeight}px)`
				}}
			>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					width="100%"
				>
					<CheckCircleIcon style={{ fontSize: 80, color: '#16a34a', marginBottom: 16 }} />
					<Typography variant="h4" style={{ fontWeight: 700, color: '#1ea3f0ff', marginBottom: 12 }}>
						Seu pedido foi efetuado!
					</Typography>
					<Typography variant="body1" style={{ color: '#333', marginBottom: 32 }}>
						Em breve você receberá a confirmação pelo WhatsApp.
					</Typography>
					<Button 
					  variant="contained" 
					  size="large" 
					  onClick={() => history.push("/selfcheckout")}
					  style={{ backgroundColor: '#14b8a6', color: '#fff' }}
					>
					  Pedir novamente
					</Button>
				</Box>
			</Box>
		</React.Fragment>
	);
}
